import { useTranslation } from 'react-i18next';

import { InstructionForm } from 'src/Components/Forms/Instruction/InstructionForm';
import {
  CreateInstructionFormProvider,
  useCreateInstructionForm,
} from 'src/Hooks/Forms/useCreateInstructionForm';
import { useCreateInstruction } from 'src/Hooks/Mutations/useCreateInstruction';

import { Props } from './InstructionCreationFormWrapper.types';

const InstructionCreationFormWrapper = ({ onCreate, onCancel }: Props) => {
  const { form, removeSection, addSection } = useCreateInstructionForm();
  const { mutate } = useCreateInstruction({ onSuccess: () => onCreate() });
  const { t } = useTranslation();

  return (
    <CreateInstructionFormProvider form={form}>
      <InstructionForm
        onCancel={onCancel}
        form={form}
        removeSection={removeSection}
        addSection={addSection}
        onSubmit={form.onSubmit(values => {
          mutate(values);
        })}
        submitButtonLabel={t('createInstructionForm.addInstruction', 'Ajouter')}
      />
    </CreateInstructionFormProvider>
  );
};

export default InstructionCreationFormWrapper;
